var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar'),_c('v-main',[_c('v-container',{staticStyle:{"max-width":"960px"}},[_vm._t("default")],2)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }